import * as React from 'react';
import classNames from 'classnames';
import { CnSelectTag } from '@/components/cn-tag';
import { CnBox } from '@/components/cn-box';
import { useValue } from '@/hooks/use-value';
// 检查值是否能够完全等同
const checkSelected = (val, values) => {
    if (Array.isArray(values)) {
        return values.includes(val);
    }
    else {
        return val === values;
    }
};
export const CnSelector = (props) => {
    const { prefix = 'cn-ui-m-', isPreview, className, dataSource = [], mode = 'single', onChange, disabled, columns, cnBoxProps, } = props;
    const [value, setValue, isControlled] = useValue(props, [], {
        fitValue: (v) => {
            return Array.isArray(v) ? v : [v];
        },
        compare: (a, b) => {
            return a.join(',') === b.join(',');
        },
    });
    const handleClick = (v) => {
        if (isPreview) {
            return;
        }
        if (mode === 'single') {
            const hasChecked = checkSelected(v, value);
            if (isControlled) {
                if (onChange) {
                    onChange(hasChecked ? undefined : v);
                }
            }
            else {
                setValue(hasChecked ? [] : [v]);
            }
        }
        else {
            const newValue = [...value];
            if (newValue.includes(v)) {
                newValue.splice(newValue.indexOf(v), 1);
            }
            else {
                newValue.push(v);
            }
            if (isControlled) {
                if (onChange) {
                    onChange(newValue);
                }
            }
            else {
                setValue(newValue);
            }
        }
    };
    const clsPrefix = `${prefix}selector`;
    const items = dataSource.map((it) => {
        const v = typeof it === 'object' ? it.value : it;
        const label = typeof it === 'object' ? it.label : it;
        const itemDisabled = disabled || (typeof it === 'object' ? it.disabled : false);
        const isSelected = checkSelected(v, value);
        return (React.createElement(CnSelectTag, { key: v, type: isSelected ? 'secondary' : 'default', disabled: itemDisabled, onClick: () => {
                if (itemDisabled)
                    return;
                handleClick(v);
            }, checked: isSelected }, label));
    });
    return (React.createElement("div", { className: classNames(clsPrefix, `${clsPrefix}--medium`, className) }, columns ? (React.createElement("div", { className: `${clsPrefix}-grid`, style: { '--columns': columns } }, items)) : (React.createElement(CnBox, { wrap: true, direction: "row", spacing: 8, ...cnBoxProps }, items))));
};
CnSelector.displayName = 'CnSelector';
CnSelector.defaultProps = {
    prefix: 'cn-ui-m-',
    mode: 'single',
};
